import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-09acd05c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = { class: "groupTitle" }
const _hoisted_3 = { class: "inputRow" }
const _hoisted_4 = { class: "flex flex-wrap" }
const _hoisted_5 = { class: "inputField flex w-1/3" }
const _hoisted_6 = ["checked"]
const _hoisted_7 = { class: "inputTitle ml-2" }
const _hoisted_8 = { for: "GEF" }
const _hoisted_9 = { class: "inputField flex w-1/3" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "inputTitle ml-2" }
const _hoisted_12 = { for: "AFG" }
const _hoisted_13 = { class: "inputField flex w-1/3" }
const _hoisted_14 = ["checked"]
const _hoisted_15 = { class: "inputTitle ml-2" }
const _hoisted_16 = { for: "BTB" }
const _hoisted_17 = { class: "inputField flex w-1/3" }
const _hoisted_18 = ["checked"]
const _hoisted_19 = { class: "inputTitle ml-2" }
const _hoisted_20 = { for: "VPB" }
const _hoisted_21 = { class: "inputField flex w-1/3" }
const _hoisted_22 = ["checked"]
const _hoisted_23 = { class: "inputTitle ml-2" }
const _hoisted_24 = { for: "SZF" }
const _hoisted_25 = { class: "inputField flex w-1/3" }
const _hoisted_26 = ["checked"]
const _hoisted_27 = { class: "inputTitle ml-2" }
const _hoisted_28 = { for: "FQA" }
const _hoisted_29 = { class: "inputGroup" }
const _hoisted_30 = { class: "groupTitle" }
const _hoisted_31 = { class: "inputRow" }
const _hoisted_32 = { class: "flex flex-wrap" }
const _hoisted_33 = { class: "inputField flex w-1/3" }
const _hoisted_34 = ["checked"]
const _hoisted_35 = { class: "inputTitle ml-2" }
const _hoisted_36 = { for: "isOpenYes" }
const _hoisted_37 = { class: "inputField flex w-1/3" }
const _hoisted_38 = ["checked"]
const _hoisted_39 = { class: "inputTitle ml-2" }
const _hoisted_40 = { for: "isOpenNo" }
const _hoisted_41 = { class: "inputGroup" }
const _hoisted_42 = { class: "groupTitle" }
const _hoisted_43 = { class: "inputGroup" }
const _hoisted_44 = { class: "groupTitle" }
const _hoisted_45 = { class: "inputGroup" }
const _hoisted_46 = { class: "groupTitle" }
const _hoisted_47 = { class: "inputGroup" }
const _hoisted_48 = { class: "groupTitle" }
const _hoisted_49 = { class: "inputGroup" }
const _hoisted_50 = { class: "groupTitle" }
const _hoisted_51 = { class: "inputRow" }
const _hoisted_52 = { class: "flex flex-wrap" }
const _hoisted_53 = { class: "inputField flex w-1/3" }
const _hoisted_54 = { class: "inputTitle ml-2" }
const _hoisted_55 = { for: "createdAtSTART" }
const _hoisted_56 = ["max"]
const _hoisted_57 = { class: "inputField flex w-1/3" }
const _hoisted_58 = { class: "inputTitle ml-2" }
const _hoisted_59 = { for: "createdAtEND" }
const _hoisted_60 = ["max"]
const _hoisted_61 = { class: "inputGroup" }
const _hoisted_62 = { class: "groupTitle" }
const _hoisted_63 = { class: "inputRow" }
const _hoisted_64 = { class: "flex flex-wrap" }
const _hoisted_65 = { class: "inputField flex w-1/3" }
const _hoisted_66 = { class: "inputTitle ml-2" }
const _hoisted_67 = { for: "changedAtSTART" }
const _hoisted_68 = ["max"]
const _hoisted_69 = { class: "inputField flex w-1/3" }
const _hoisted_70 = { class: "inputTitle ml-2" }
const _hoisted_71 = { for: "changedAtEND" }
const _hoisted_72 = ["max"]
const _hoisted_73 = { class: "inputGroup" }
const _hoisted_74 = { class: "groupTitle" }
const _hoisted_75 = { class: "inputRow" }
const _hoisted_76 = { class: "flex flex-wrap" }
const _hoisted_77 = { class: "inputField flex w-1/3" }
const _hoisted_78 = { class: "inputTitle ml-2" }
const _hoisted_79 = { for: "finishedAtSTART" }
const _hoisted_80 = ["max"]
const _hoisted_81 = { class: "inputField flex w-1/3" }
const _hoisted_82 = { class: "inputTitle ml-2" }
const _hoisted_83 = { for: "finishedAtEND" }
const _hoisted_84 = ["max"]

import {computed, onMounted, ref} from "vue";
import {useSystemStore} from "@/stores/system/SystemStore";
import {TableType} from "@/utilities/system/enums/Enums";
import FilterService from "@/utilities/system/services/FilterService";
import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";



export default /*#__PURE__*/_defineComponent({
  __name: 'FormReportFilterPopup',
  setup(__props) {

const systemStore = useSystemStore();

const todayDateString = new Date().toISOString().split('T')[0];
const dateRefs =  ref({
    createdAtSTART: undefined,
    createdAtEND: undefined,
    changedAtSTART: undefined,
    changedAtEND: undefined,
    finishedAtSTART: undefined,
    finishedAtEND: undefined
});

const userFilters = computed(()=>{
  return systemStore.userPreferences.userFilters;
});
const userHiddenColumns = computed(()=>{
  return systemStore.userPreferences.userHiddenColumns;
});


const tmpUserFilters = computed(()=>{
  return systemStore.tmpPreferences.tmpUserFilters;
});
const tmpUserHiddenColumns = computed(()=>{
  return systemStore.tmpPreferences.tmpUserHiddenColumns;
});

// init checkboxes according to tmpFilters [attributeValue == input-id]
const isFiltered = (attName:string, attVal:string) => {
  return tmpUserFilters.value.some(tuf => tuf.attributeName === attName && tuf.attributeValue === attVal.toString());
};

// init visibility buttons according to tmpHiddenColumns
const isHidden = (attName:string) => {
  return tmpUserHiddenColumns.value.some(thc => thc.attributeName === attName.toString());
};

const computeFilterAction = (target:any, propName:string):boolean|null => {
  // when date value just return if it is undefined or not
  if(propName.endsWith("START") || propName.endsWith("END")){
    return !NullOrUndefinedHelper(target.value);
  }

  // when it is static checkbox filter return if the target is checked
  if(!NullOrUndefinedHelper(target.checked)){
    return target.checked;
  }

  // when its neither static checkbox nor date filter, wtf have we done?
  console.log(`unkown filter action to compute for prop: '${propName}'`);
  return null;
}

const filterChanged = ({ target }:any, propName:string) => {
  //TODO check for END < START and swap em

  const addFilter = computeFilterAction(target, propName);
  if(addFilter === null) return;

  if(addFilter) {
    // add to tmpFilterList
    systemStore.addUserFilter({tableName: TableType[TableType.form], attributeName: propName, attributeValue: target.value.toString()});
  }
  else {
    // remove from tmpFilterList
    tmpUserFilters.value.forEach((tuf,index)=>{
      if(tuf.attributeName === propName && tuf.attributeValue === target.value.toString()) tmpUserFilters.value.splice(index, 1);
      // check for dateValues and remove, validity check (for undefined) already done in computeFilterAction()
      if(tuf.attributeName === propName && (propName.endsWith("START") || propName.endsWith("END"))) tmpUserFilters.value.splice(index, 1);
    });

    systemStore.setTmpFilters(tmpUserFilters.value);
  }

  calculateRestEntities();
};

const visibilityChange = (colName:string) => {
  if(!tmpUserHiddenColumns.value.some(thc => thc.attributeName === colName)) {
    // add to tmpHiddenColumnList
    systemStore.addUserHiddenColumn({ tableName: TableType[TableType.form], attributeName: colName, attributeValue: "" });
  }
  else {
    // remove from tmpHiddenColumnList
    tmpUserHiddenColumns.value.forEach((thc,index)=>{
      if(thc.attributeName === colName) tmpUserHiddenColumns.value.splice(index, 1);
    });

    systemStore.setTmpHiddenColumns(tmpUserHiddenColumns.value);
  }

  calculateRestEntities();
};


const calculateRestEntities = () => {
  const allRecords = systemStore.gridStore?.storage.allValues;
  const tmpFilterMethod = FilterService.buildFilter(TableType[TableType.form], true);

  let counter = 0;

  allRecords.forEach((r:any) => {
    if (tmpFilterMethod(r)) counter++;
  });

  systemStore.setCountAfterFilters(counter);
};

const setDateFilterValues = ()=>{
  const datePrefs = tmpUserFilters.value.filter(tf => tf.tableName === TableType[TableType.form] && (tf.attributeName.endsWith("START") || tf.attributeName.endsWith("END")));
  for(const datePref of datePrefs){
    //@ts-expect-error
    dateRefs.value[`${datePref.attributeName}`] = datePref.attributeValue;
  }
}

onMounted(async ()=>{
  //init tmp values
  systemStore.setTmpFilters(userFilters.value.filter(f => f.tableName === TableType[TableType.form]));
  systemStore.setTmpHiddenColumns(userHiddenColumns.value.filter(f => f.tableName === TableType[TableType.form]));

  //init dateValues
  setDateFilterValues();

  // init afterFilters count
  systemStore.setCountAfterFilters(systemStore.gridStore?.count);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('formReports.popups.filters.type')), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("input", {
                checked: isFiltered('type', '0'),
                type: "checkbox",
                id: "GEF",
                value: "0",
                onChange: _cache[0] || (_cache[0] = (e) => filterChanged(e, 'type'))
              }, null, 40, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('formReports.popups.filters.GEF')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                checked: isFiltered('type', '1'),
                type: "checkbox",
                id: "AFG",
                value: "1",
                onChange: _cache[1] || (_cache[1] = (e) => filterChanged(e, 'type'))
              }, null, 40, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('formReports.popups.filters.AFG')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("input", {
                checked: isFiltered('type', '2'),
                type: "checkbox",
                id: "BTB",
                value: "2",
                onChange: _cache[2] || (_cache[2] = (e) => filterChanged(e, 'type'))
              }, null, 40, _hoisted_14),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('formReports.popups.filters.BTB')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("input", {
                checked: isFiltered('type', '3'),
                type: "checkbox",
                id: "VPB",
                value: "3",
                onChange: _cache[3] || (_cache[3] = (e) => filterChanged(e, 'type'))
              }, null, 40, _hoisted_18),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('formReports.popups.filters.VPB')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("input", {
                checked: isFiltered('type', '4'),
                type: "checkbox",
                id: "SZF",
                value: "4",
                onChange: _cache[4] || (_cache[4] = (e) => filterChanged(e, 'type'))
              }, null, 40, _hoisted_22),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('formReports.popups.filters.SZF')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("input", {
                checked: isFiltered('type', '5'),
                type: "checkbox",
                id: "FQA",
                value: "5",
                onChange: _cache[5] || (_cache[5] = (e) => filterChanged(e, 'type'))
              }, null, 40, _hoisted_26),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('formReports.popups.filters.FQA')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.popups.filters.isOpen')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('isOpen') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (visibilityChange('isOpen')))
        }, null, 2)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("input", {
                checked: isFiltered('isOpen', 'true'),
                type: "checkbox",
                id: "isOpenYes",
                value: "true",
                onChange: _cache[7] || (_cache[7] = (e) => filterChanged(e, 'isOpen'))
              }, null, 40, _hoisted_34),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('formReports.popups.filters.isOpenYes')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("input", {
                checked: isFiltered('isOpen', 'false'),
                type: "checkbox",
                id: "isOpenNo",
                value: "false",
                onChange: _cache[8] || (_cache[8] = (e) => filterChanged(e, 'isOpen'))
              }, null, 40, _hoisted_38),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('formReports.popups.filters.isOpenNo')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.grid.id')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('id') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (visibilityChange('id')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.grid.creatorName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('creatorName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (visibilityChange('creatorName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.grid.locationName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('locationName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[11] || (_cache[11] = ($event: any) => (visibilityChange('locationName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _createElementVNode("div", _hoisted_48, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.grid.facilityName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('facilityName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[12] || (_cache[12] = ($event: any) => (visibilityChange('facilityName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.grid.createdAt')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('createdAt') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[13] || (_cache[13] = ($event: any) => (visibilityChange('createdAt')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('general.from')), 1),
              _withDirectives(_createElementVNode("input", {
                class: "dateInput",
                type: "date",
                id: "createdAtSTART",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dateRefs.value.createdAtSTART) = $event)),
                onChange: _cache[15] || (_cache[15] = (e) => filterChanged(e, 'createdAtSTART')),
                min: "2024-08-01",
                max: _unref(todayDateString)
              }, null, 40, _hoisted_56), [
                [_vModelText, dateRefs.value.createdAtSTART]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('general.to')), 1),
              _withDirectives(_createElementVNode("input", {
                class: "dateInput",
                type: "date",
                id: "createdAtEND",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((dateRefs.value.createdAtEND) = $event)),
                onChange: _cache[17] || (_cache[17] = (e) => filterChanged(e, 'createdAtEND')),
                min: "2024-08-01",
                max: _unref(todayDateString)
              }, null, 40, _hoisted_60), [
                [_vModelText, dateRefs.value.createdAtEND]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_61, [
      _createElementVNode("div", _hoisted_62, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.grid.changedAt')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('changedAt') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[18] || (_cache[18] = ($event: any) => (visibilityChange('changedAt')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t('general.from')), 1),
              _withDirectives(_createElementVNode("input", {
                class: "dateInput",
                type: "date",
                id: "changedAtSTART",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((dateRefs.value.changedAtSTART) = $event)),
                onChange: _cache[20] || (_cache[20] = (e) => filterChanged(e, 'changedAtSTART')),
                min: "2024-08-01",
                max: _unref(todayDateString)
              }, null, 40, _hoisted_68), [
                [_vModelText, dateRefs.value.changedAtSTART]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('general.to')), 1),
              _withDirectives(_createElementVNode("input", {
                class: "dateInput",
                type: "date",
                id: "changedAtEND",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((dateRefs.value.changedAtEND) = $event)),
                onChange: _cache[22] || (_cache[22] = (e) => filterChanged(e, 'changedAtEND')),
                min: "2024-08-01",
                max: _unref(todayDateString)
              }, null, 40, _hoisted_72), [
                [_vModelText, dateRefs.value.changedAtEND]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_73, [
      _createElementVNode("div", _hoisted_74, [
        _createTextVNode(_toDisplayString(_ctx.$t('formReports.grid.finishedAt')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('finishedAt') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[23] || (_cache[23] = ($event: any) => (visibilityChange('finishedAt')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_75, [
        _createElementVNode("div", _hoisted_76, [
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('general.from')), 1),
              _withDirectives(_createElementVNode("input", {
                class: "dateInput",
                type: "date",
                id: "finishedAtSTART",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((dateRefs.value.finishedAtSTART) = $event)),
                onChange: _cache[25] || (_cache[25] = (e) => filterChanged(e, 'finishedAtSTART')),
                min: "2024-08-01",
                max: _unref(todayDateString)
              }, null, 40, _hoisted_80), [
                [_vModelText, dateRefs.value.finishedAtSTART]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("label", _hoisted_83, _toDisplayString(_ctx.$t('general.to')), 1),
              _withDirectives(_createElementVNode("input", {
                class: "dateInput",
                type: "date",
                id: "finishedAtEND",
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((dateRefs.value.finishedAtEND) = $event)),
                onChange: _cache[27] || (_cache[27] = (e) => filterChanged(e, 'finishedAtEND')),
                min: "2024-08-01",
                max: _unref(todayDateString)
              }, null, 40, _hoisted_84), [
                [_vModelText, dateRefs.value.finishedAtEND]
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})